import { Injectable, inject } from '@angular/core';

import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TimezonesService } from '../services/timezones/timezones.service';

/**
 * Resolver to fetch all timezones
 */
@Injectable()
export class TimezonesResolver {
  private readonly timezonesService = inject(TimezonesService);


  resolve() {
    return this.timezonesService
      .getTimezones()
      .pipe(catchError((err) => of([])));
  }
}
